































import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'
import WizardService from '@services/Wizard'
import LocationSelector from './LocationSelector';
import states from '@assets/states.json'
import dmas from '@assets/dma.json'
import cities from '@assets/cities.json'

settings =
  name: "LocationStep"

  vue:
    props: ['wizard']
    mixins: [WizardService.step()]
    components: { LocationSelector }

    data: ->
      setLocations: false

    mounted: ->
      @initializeSetLocations()

    computed:
      actionsForLocationSelector: ->
        {
          select: @selectLocation,
          unselect: @unselectLocation,
          unselectAll: @unselectAllLocations,
        }

    methods:
      initializeSetLocations: ->
        { state_list: dataStates, dma_list: dataDMAs, city_list: dataCity } = @wizard.campaignData.target.geo
        @setLocations = true if dataStates.length or dataDMAs.length or dataCity.length

      unselectAllLocations: ->
        @wizard.campaignData.target.geo.state_list = []
        @wizard.campaignData.target.geo.dma_list = []
        @wizard.campaignData.target.geo.city_list = []

      selectLocation: (location) ->
        listName = @dataListForLocation location
        @wizard.campaignData.target.geo["#{listName}_list"].push location.key
        @syncTargetGeo()

      unselectLocation: (location) ->
        listName = @dataListForLocation location
        @wizard.campaignData.target.geo["#{listName}_list"] = @wizard.campaignData.target.geo["#{listName}_list"].filter((s) -> s isnt location.key)

      dataListForLocation: (location) ->
        list = 'dma' if location.type is 'DMA'
        list = 'city' if location.type is 'City'
        list ||= 'state'
        list

      syncTargetGeo: ->
        @wizard.campaignData.target.geo = Object.assign({}, @wizard.campaignData.target.geo)

      hiToggleSetLocations: (value) ->
        @setLocations = value

        if value
          @wizard.scrollStepToSection('#section-geo-state') if !@setLocations
        else
          @unselectAllLocations()

export default VueOptions.vue settings
